import { EachAssigneesRes } from './Assignees';

export interface AuthUserI {
  imageUrl: string;
  name: string;
  email: string;
  token: string;
  id: number;
  isAdmin?: boolean;
}

class AuthUser {
  authUser: AuthUserI;
  constructor(authUser: AuthUserI) {
    this.authUser = authUser;
  }
  toEachAssigneeRes(): EachAssigneesRes {
    return {
      id: this.authUser.id,
      imageUrl: this.authUser.imageUrl,
      name: this.authUser.name,
      address: this.authUser.email,
    };
  }
}

export default AuthUser;
